<template>
  <div v-if="searchedItems.length > 0" class="kk_formula-search" :style="styles">
    <div
      v-for="(item, index) in searchedItems"
      :key="index"
      class="kk_formula-search_item"
      :class="{ 'kk_formula-search_item-active': index === activeIndex }"
      @click="click(item)"
    >
      <i :class="item.icon"></i>
      <span>{{ item.value }}</span>
      <span>{{ item.title }}</span>
    </div>
  </div>
</template>
<script>
import hotkeys from "hotkeys-js";
import { HotkeyScopes } from "../../../utils/constants";

export default {
  props: ["collection", "inputText", "searchedItems", "styles"],
  emits: ["select-formula"],
  data() {
    return {
      activeIndex: 0,
      previousScope: null,
      selectedFormula: null,
    };
  },
  watch: {
    searchedItems() {
      this.activeIndex = 0;
    },
  },
  mounted() {
    this.previousScope = hotkeys.getScope();
    this.$store.dispatch("setScope", HotkeyScopes.FormulaSearch);

    hotkeys("up", HotkeyScopes.FormulaSearch, (event, handler) => {
      event?.preventDefault();
      this.moveUp();
      this.scroll();
    });
    hotkeys("down", HotkeyScopes.FormulaSearch, (event, handler) => {
      event?.preventDefault();
      this.moveDown();
      this.scroll();
    });
    hotkeys("tab", HotkeyScopes.FormulaSearch, (event, handler) => {
      event?.preventDefault();
      this.selectedFormula = this.searchedItems[this.activeIndex];
      this.$emit("select-formula", this.selectedFormula);
    });
  },
  beforeUnmount() {
    hotkeys.unbind("up, down, tab", HotkeyScopes.FormulaSearch);
    this.$store.dispatch("setScope", this.previousScope);
  },
  methods: {
    moveDown() {
      if (this.activeIndex === this.searchedItems.length - 1) return;
      this.activeIndex++;
    },
    moveUp() {
      if (this.activeIndex == 0) return;
      this.activeIndex--;
    },
    scroll() {
      const activeItem = document.querySelector(".kk_formula-search_item-active")?.getBoundingClientRect();
      if (!activeItem) return;
      const container = document.querySelector(".kk_formula-search");
      const containerBound = container.getBoundingClientRect();

      if (activeItem.top - 15 < containerBound.top) {
        let scrollTop = Math.ceil(container.scrollTop - 70.6);
        container.scrollTop = scrollTop;
      }
      if (activeItem.bottom + 15 > containerBound.bottom) {
        let scrollTop = Math.ceil(container.scrollTop + 70.6);
        container.scrollTop = scrollTop;
      }
    },
    click(item) {
      this.$emit("select-formula", item);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables.less";
.kk_formula-search {
  position: absolute;
  top: 110%;
  min-width: 12rem;
  width: max-content;
  max-height: 15rem;
  overflow: auto;
  background-color: white;
  border: 1px solid @kk-color-light-gray;
  border-radius: @kk-border-radius;
  z-index: 1100;
  &_item {
    padding: 0.2rem;
    display: flex;
    gap: 0.5rem;
    &-active,
    &:hover {
      background-color: @kk-color-light-blue;
    }
  }
}
</style>
